<template>
  <div class="fc-widget-content-bottom">
    <div title="PVP">
      <strong>{{ this.data.current_online_price }}€</strong>
    </div>

    <div class="flex">
      <span title="ADR">{{ this.data.adr }}€</span>
      <span title="Occupation" class="occ" :class="this.data.occ_status"
        >{{ this.data.occupancy }}%</span
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};
</script>
<style lang="scss">
.fc-widget-content-bottom {
  line-height: 1.5em;

  strong {
    font-size: 1.1em;
  }
  & > * {
    text-align: center;
    padding: 0 10px;
  }
  & > .flex {
    display: flex;
    justify-content: space-between;
  }

  .occ {
    &.over {
      color: green;
    }
    &.under {
      color: red;
    }
  }
}
</style>
